module.exports = __webpack_public_path__ + "c6b363f5c444235ad6ebba5a832480e9.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/all.png
// module id = 1743
// module chunks = 2